import apiClient from 'apiClient';
import {
  CaseId,
  CaseResponse,
  API_PREFIX,
  GetCaseResponseData,
  PatchApplicantAddressResponseData,
  PatchPowerOfAttorneyResponseData,
} from './types';
import { CaseData } from 'modules/cm/api/cases/types';
import withCaseErrorMiddleware from './caseError/withCaseErrorMiddleware';

export const getCaseById = (caseId: CaseId): CaseResponse => {
  return apiClient.get<GetCaseResponseData>(`${API_PREFIX}/${caseId}`).then(withCaseErrorMiddleware);
};

export const saveCase = (caseData: CaseData, repaymentStrategyData: any): CaseResponse => {
  return apiClient
    .post(`${API_PREFIX}/${caseData.caseId}`, { ...caseData, repaymentStrategy: repaymentStrategyData })
    .then(withCaseErrorMiddleware);
};

export const patchApplicantAddress = (
  caseId: CaseId,
  applicantId: number,
  addressId: number,
  field: string,
  value: any,
): CaseResponse => {
  return apiClient
    .patch<PatchApplicantAddressResponseData>(`${API_PREFIX}/${caseId}/applicant/${applicantId}/address/${addressId}`, {
      [field]: value,
    })
    .then(withCaseErrorMiddleware);
};

export const patchApplicantPoa = (
  caseId: string,
  applicantId: number,
  poaId: number,
  field: string,
  value: any,
): CaseResponse => {
  return apiClient
    .patch<PatchPowerOfAttorneyResponseData>(`${API_PREFIX}/${caseId}/applicant/${applicantId}/poa/${poaId}`, {
      [field]: value,
    })
    .then(withCaseErrorMiddleware);
};
